var _style, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 509.4 265.2",
    style: {
      enableBackground: "new 0 0 509.4 265.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{clip-path:url(#SVGID_00000020373417871970280050000007573445450843096964_);}\n\t.st2{fill:url(#SVGID_00000101071006763222174520000000433262007052655239_);}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M308.1,220.5c-0.3-1.9-2-3.3-3.9-3.2c-1.8-0.2-3.4,1.2-3.6,3c0,0,0,0,0,0.1c0,1.4,1,2.6,2.4,2.7l2.8,0.6 c3.1,0.7,4.8,2.6,4.8,5.2c0,2.9-2.5,5.5-6.4,5.5c-4.5,0-6.6-2.9-6.9-5.5l2.5-0.8c0.1,2.3,2.1,4.1,4.4,4l0,0c2.6,0,3.8-1.3,3.8-3 c0-1.3-0.9-2.5-2.8-2.9l-2.6-0.6c-2.6-0.6-4.5-2.3-4.5-5.1s2.7-5.5,6.1-5.5c4.2,0,5.9,2.6,6.3,4.6L308.1,220.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "333.2,234 333.2,225.8 323.7,225.8 323.7,234 321.2,234 321.2,215.5 323.7,215.5 323.7,223.4  333.2,223.4 333.2,215.5 335.8,215.5 335.8,234  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M355.7,215.1c5.3-0.2,9.8,4,10,9.3s-4,9.8-9.3,10c-5.3,0.2-9.8-4-10-9.3c0,0,0,0,0,0c0-0.1,0-0.3,0-0.4 c-0.2-5.1,3.8-9.4,8.8-9.6L355.7,215.1 M355.7,232.1c3.5,0,6.7-2.5,6.7-7.3s-3.2-7.3-6.7-7.3s-6.7,2.5-6.7,7.3 S352.2,232.1,355.7,232.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M378.1,226.5v7.6h-2.6v-18.5h6.7c3,0,5.5,2.5,5.5,5.5s-2.5,5.5-5.5,5.5h-4.1V226.5z M381.8,224.2 c2.2,0,3.6-1.2,3.6-3.1s-1.4-3.2-3.6-3.2h-3.7v6.4L381.8,224.2L381.8,224.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M400.8,226.5v7.6h-2.6v-18.5h6.7c3,0,5.5,2.5,5.5,5.5s-2.5,5.5-5.5,5.5h-4.1L400.8,226.5L400.8,226.5z  M404.5,224.2c2.2,0,3.6-1.2,3.6-3.1s-1.4-3.2-3.6-3.2h-3.7v6.4L404.5,224.2L404.5,224.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.9,
    y: 215.5,
    className: "st0",
    width: 2.6,
    height: 18.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "447.8,234 437.8,218.9 437.8,234 435.3,234 435.3,215.5 438.7,215.5 448,229.7 448,215.5  450.5,215.5 450.5,234  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M476.3,234l-0.2-2.6c-0.8,1.5-2.8,3-5.9,3c-4.7,0-9-3.4-9-9.7s4.6-9.6,9.2-9.6c3.7-0.2,7,2.1,8.2,5.6l-2.3,1 c-0.7-2.6-3.2-4.4-5.9-4.2c-3.3,0-6.6,2.4-6.6,7.3s3.1,7.3,6.5,7.3c4.1,0,5.6-2.9,5.7-4.8h-6.4V225h8.9v9.1L476.3,234L476.3,234z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M400.5,146h-17.3v-39.5c0-1.2-0.1-2.4-0.4-3.6c-0.3-1.5-0.9-3-1.7-4.3c-0.9-1.5-2.2-2.7-3.8-3.5 c-5.4-2.5-11.6-1.6-16.2,2.1c-2.5,2.5-3.8,5.8-3.7,9.3V146h-17.3v-39.5c0-1.2-0.1-2.4-0.4-3.6c-0.3-1.5-0.8-3-1.6-4.3 c-0.9-1.5-2.2-2.7-3.7-3.5c-5.4-2.5-11.7-1.6-16.3,2.1c-2.4,2.5-3.7,5.8-3.6,9.3V146h-17.3v-39.1c-0.1-4.1,0.7-8.1,2.2-11.9 c2.8-7.3,8.5-13.1,15.7-16c4-1.6,8.3-2.3,12.6-2.3c4.3-0.1,8.5,0.8,12.4,2.6c3.5,1.6,6.6,4,9.1,7c2.5-3,5.7-5.4,9.3-7 c3.8-1.7,8-2.6,12.2-2.6c4.3-0.1,8.6,0.7,12.6,2.2c7.2,2.7,12.7,8.5,15.3,15.7c1.4,3.9,2.1,8,2,12.2V146H400.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.2,
    y: 30.8,
    className: "st0",
    width: 18.6,
    height: 115.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.6,98.6c-3.2-8.5-9.7-15.3-18-19c-17.3-7.8-37.7-0.1-45.5,17.2c-0.2,0.5-0.4,1-0.6,1.5 c-1.7,4.3-2.6,8.9-2.6,13.6c-0.1,4.6,0.8,9.1,2.5,13.3c3.2,8.1,9.4,14.6,17.4,18.1c4.1,1.8,8.6,2.7,13.1,2.7h36.3v-33.6 C253.2,107.7,252.3,103,250.6,98.6 M229,129.2h-10c-2.4,0-4.8-0.4-7-1.3c-2.1-0.9-4-2.1-5.6-3.6c-1.6-1.5-2.9-3.4-3.7-5.4 c-0.9-2.2-1.4-4.5-1.4-6.9c0-2.4,0.5-4.8,1.4-7.1c0.9-2.1,2.1-4.1,3.7-5.8c1.5-1.7,3.4-3,5.5-3.9c4.3-1.9,9.2-1.9,13.4,0.1 c4.2,2.1,7.5,5.7,9.2,10.1c0.9,2.3,1.4,4.8,1.4,7.3v16.8H229V129.2L229,129.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M475.9,98.6c-3.2-8.5-9.7-15.3-18-19c-17.3-7.8-37.7-0.1-45.5,17.2c-0.2,0.5-0.4,1-0.6,1.5 c-1.7,4.3-2.6,8.9-2.6,13.6c-0.1,4.6,0.8,9.1,2.5,13.3c3.1,8.1,9.4,14.6,17.4,18.1c4.1,1.8,8.6,2.8,13.1,2.7h36.2v-33.6 C478.5,107.7,477.6,103,475.9,98.6 M454.2,129.2h-10c-2.4,0-4.8-0.4-7-1.3c-2.1-0.9-4-2.1-5.6-3.6c-1.6-1.5-2.9-3.4-3.7-5.4 c-0.9-2.2-1.4-4.5-1.4-6.9c0-2.4,0.5-4.8,1.4-7.1c0.9-2.1,2.1-4.1,3.7-5.8c4.8-5.2,12.4-6.7,18.9-3.8c4.2,2.1,7.5,5.7,9.2,10.1 c0.9,2.3,1.4,4.8,1.4,7.3v16.8h-6.9V129.2L454.2,129.2z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M80.7,120.7c-3.9-1.6-7.4-3.8-10.4-6.7c-3-2.8-5.3-6.1-7-9.8c-1.7-3.7-2.6-7.8-2.6-11.9 c0-4.1,0.9-8.2,2.7-11.9c1.8-3.7,4.2-7,7.2-9.8c3.1-2.8,6.7-5.1,10.6-6.7c4.2-1.7,8.6-2.5,13.1-2.5h29.9v12.4l0,0v17.7 c0,4.3-0.7,8.5-2.3,12.5c-3,7.5-8.7,13.4-16.1,16.6c-3.9,1.7-8.1,2.5-12.4,2.5C89,123.2,84.7,122.4,80.7,120.7 M94.4,30.8 c-8.4-0.1-16.8,1.5-24.6,4.6c-7.5,2.9-14.3,7.2-20.2,12.7c-12.2,11.5-19,27.6-18.7,44.4c-0.5,25.2,14.8,48.1,38.3,57.3 c15.4,6,32.5,6,47.9,0.1c14.5-5.7,26.1-16.9,32.3-31.1c3.2-7.3,4.9-15.3,4.8-23.3V30.8L94.4,30.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181766145248260769440000011300713078703011773_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181766145248260769440000011300713078703011773_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182515905038818378580000013646875981046964629_",
    gradientUnits: "userSpaceOnUse",
    x1: -865.9587,
    y1: 689.6219,
    x2: -864.9587,
    y2: 689.6219,
    gradientTransform: "matrix(105.4508 -105.4508 -105.4508 -105.4508 164085.0781 -18457.6621)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4A0D62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#4A0D62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#741469"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#9F1C6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#C02174"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#D82678"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#E7287A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#EC297B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#EC2B78"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#EE3C5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#EF4944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    style: {
      stopColor: "#EF5334"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#F0582B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F05A28"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE4036"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000182515905038818378580000013646875981046964629_)"
    },
    points: "-30.8,92.5 92.5,-30.8  215.9,92.5 92.5,215.9  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlma);
export default __webpack_public_path__ + "static/media/alma.b3fa7a5584b1d0b774bbdc28c6577f96.svg";
export { ForwardRef as ReactComponent };